"use strict";

module.exports = function () {
  return JSON.stringify(this.customQueries);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/custom-q.js
// module id = 1576
// module chunks = 61